import React, { useContext } from "react";
import NewLMRGroup from "../components/lmrGroups/NewLmrGroups";
import OrgContext from "../store/orgContext";
import InfoAlert from "../ui/InfoAlert";
import SectionHeader from "../components/section/SectionHeader";
import ESOganisationDropdown from "../components/dropdown/esOrganisationDropdown";
import { CREATE_LMR_GROUP_TRANSLATIONS } from "../translations/util";

const NewLMRGroups = () => {
  const { orgs: orgList, selectedOrg, updateOrg } = useContext(OrgContext);

  return (
    <>
      <SectionHeader
        pageTitle={CREATE_LMR_GROUP_TRANSLATIONS.header}
        pageDescription={CREATE_LMR_GROUP_TRANSLATIONS.headerSubtext}
        showBackButton
        sideComponent={
          <div className="dropdown-details">
            <ESOganisationDropdown
              disabled
              org={selectedOrg || undefined}
              orgsList={orgList}
              setOrg={updateOrg}
            />
          </div>
        }
      />
      <div className="main-content">
        {selectedOrg ? (
          <NewLMRGroup org={selectedOrg.id} />
        ) : (
          <InfoAlert
            heading={CREATE_LMR_GROUP_TRANSLATIONS.infoAlert.heading}
            subText={CREATE_LMR_GROUP_TRANSLATIONS.infoAlert.subText}
          />
        )}
      </div>
    </>
  );
};

export default NewLMRGroups;
